module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei2.svg";